module.exports = __webpack_public_path__ + "static/media/Nimbella-Logo.e3bced65.svg";